import React from 'react';
import {Button} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash} from '@fortawesome/free-solid-svg-icons';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import './ChantierInfoFile.css';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {useNavigate} from 'react-router';
import {useParams} from 'react-router-dom';

/**
 * Vue de l'historique d'un chantier
 * @param {*} props props
 * @return {JSX}
 */
function ChantierInfoFileView(props) {
  const navigate = useNavigate();
  const {id} = useParams();
  const returnTo = 'pasHistorique'

  return (
    <React.Fragment>
      <Button
        style={{backgroundColor: '#212529', color: 'white', marginBottom: '15px'}}
        onClick={props.addFile}>
        Ajouter PDF
      </Button>
      <div className="chantierheure-filter-container">
        <input
          type="text"
          value={props.inputRef}
          onChange={props.handleChange}
          className="chantierheure-input"
          placeholder="Filtrer par nom de PDF" />
        <DatePicker
          className="chantierheure-form-control"
          type="date"
          selected={props.dateRef}
          onChange={props.handleDateChange}
          placeholderText="Filtrer par date"
          dateFormat="dd-MM-yyyy" />
        <FontAwesomeIcon
          className="chantierheure-trash-icon"
          icon={faTrash}
          onClick={() => props.removeDate()} />
      </div>
      <div className="chantierheure-filter-container">
        <DatePicker
          className="chantierheure-form-control2"
          type="text"
          selected={props.dateRef}
          onChange={props.handleDateChange}
          placeholderText="Filtrer par date"
          dateFormat="dd-MM-yyyy" />
        <FontAwesomeIcon
          className="chantierheure-trash-icon2"
          icon={faTrash}
          onClick={() => props.removeDate()} />
      </div>
      <div>
        <MDBCheckbox name='extra1' label='Extra possible' inline onChange={props.handleCheckboxChange}/>
        {localStorage.getItem('admin') === '1' ?
        <React.Fragment>
          <MDBCheckbox name='extra2' label='Extra valider' inline onChange={props.handleCheckboxChange} />
          <MDBCheckbox name='extra3' label='Extra confirmer' inline onChange={props.handleCheckboxChange}/>
        </React.Fragment> : '' }
      </div>
      {!props.imageOnScreen ?<Button
        style={{backgroundColor: '#212529', color: 'white'}}
        onClick={() => props.getFiles()}>
        Afficher les PDF
      </Button> : ''}
      <div className="photo-grid">
        {props.filteredArray.map((file, index) => {
          return <React.Fragment key={file.id}>
            {localStorage.getItem('admin') === '1' || file.permission === false ?
      <div className="chantierheure-photo-card" style={{backgroundColor: 'white', height: '390px'}}>
        <div>
          <LazyLoadImage
            style={{width: '90px', height: '90px'}}
            src="/images/pdf.png"
            alt="error"
            className="chantierheure-photo"
            placeholderSrc="/images/pdf.png"
            effect="blur"
          />
        </div>
        <div className="chantierheure-photo-info">
          <p className="chantierheure-photo-description">{file.name}</p>
          <p className="chantierheure-photo-description">{file.date}</p>
          <MDBCheckbox name="inlineCheck" id="inlineCheckbox1a" checked={file.extra1} inline label="Extra possible" disabled />
          {localStorage.getItem('admin') === '1' && (
            <React.Fragment>
              <MDBCheckbox name="inlineCheck" id="inlineCheckbox2a" checked={file.extra2} inline label="Extra validé" disabled />
              <MDBCheckbox name="inlineCheck" id="inlineCheckbox3a" checked={file.extra3} inline label="Extra confirmé" disabled />
            </React.Fragment>
          )}
          {localStorage.getItem('admin') === '1' ?
                <div className="app" style={{textAlign: 'center', marginTop: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <label className="labelFacture" style={{marginRight: '25px'}}>PDF Privé ?</label>
                  <div className="toggle-switch" style={{marginBottom: '5px'}}>
                    <div>
                      <input
                        id="toggle2"
                        checked={file.permission}
                        disabled
                        type="checkbox"/>
                      <label htmlFor="toggle2"></label>
                    </div>
                  </div>
                </div> : ''}

          <p className="chantierheure-photo-description" style={{paddingRight: '12px', paddingLeft: '12px', marginBottom: '10px'}}>
            {file.note}
          </p>

          <Button onClick={() => {
            navigate('/UpdateFile', {state: {file, id, returnTo}});
          }} style={{marginTop: '0px', marginRight: '10px', backgroundColor: 'red', color: 'white'}}>

        Selectionner
          </Button>
        </div>
      </div> : ''}
          </React.Fragment>;
        })}
      </div>
    </React.Fragment>
  );
}

export default ChantierInfoFileView;
